'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import type { IContactUs } from './Contactus';
interface HubSpotMeetingProps {
  formData?: IContactUs | null;
  onExit?: () => void;
}
const HubSpotMeeting = t0 => {
  const $ = _c(12);
  const {
    formData,
    onExit
  } = t0;
  let t1;
  let t2;
  if ($[0] !== formData) {
    t1 = () => {
      window.scrollTo(0, 0);
      let meetingUrl = "https://meetings.hubspot.com/meet-singhal/demo?embed=true";
      if (formData) {
        let firstName = formData.firstName || "";
        let lastName = formData.lastName || "";
        if (!firstName && formData.name) {
          const nameParts = formData.name.trim().split(" ");
          firstName = nameParts[0] || "";
          lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
        }
        meetingUrl = "https://meetings.hubspot.com/meet-singhal/demo?embed=true" + `&firstname=${encodeURIComponent(firstName)}&lastname=${encodeURIComponent(lastName)}&email=${encodeURIComponent(formData.email)}&mobilephone=${encodeURIComponent(formData.phone || "")}`;
      }
      const container = document.getElementById("hubspot-meetings-container");
      if (container) {
        container.setAttribute("data-src", meetingUrl);
      }
      const script = document.createElement("script");
      script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    };
    t2 = [formData];
    $[0] = formData;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h1 className="block text-lg font-bold text-gray-900 md:text-2xl">Schedule a Meeting</h1>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onExit) {
    t4 = onExit && <p className="mt-2 text-sm text-gray-600">Prefer to have someone contact you within 24 hours?{" "}<button type="button" onClick={onExit} className="text-blue-500 underline hover:text-blue-700">Click here to exit</button></p>;
    $[4] = onExit;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="mb-4 text-center">{t3}{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex w-full justify-center"><div id="hubspot-meetings-container" className="meetings-iframe-container w-full" data-src="https://meetings.hubspot.com/meet-singhal/demo?embed=true" /></div>;
    t7 = <style>{"\n          .meetings-iframe-container {\n            width: 100%;\n            overflow: visible;\n          }\n          .meetings-iframe-container iframe {\n            height: 700px;\n            width: 100%;\n            border: none;\n          }\n\n          @media (max-width: 768px) {\n            .meetings-iframe-container iframe {\n              height: 650px;\n            }\n          }\n        "}</style>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5) {
    t8 = <div className="w-full bg-white pb-6 pt-24"><div className="mx-auto h-full max-w-7xl px-4">{t5}{t6}{t7}</div></div>;
    $[10] = t5;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default HubSpotMeeting;